import theme from "@/theme";

const BlueCheckedSquareIcon = () => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 4C5.79086 4 4 5.79086 4 8V18C4 20.2091 5.79086 22 8 22H18C20.2091 22 22 20.2091 22 18V8C22 5.79086 20.2091 4 18 4H8ZM16.7071 11.7071C17.0976 11.3166 17.0976 10.6834 16.7071 10.2929C16.3166 9.90237 15.6834 9.90237 15.2929 10.2929L12 13.5858L10.7071 12.2929C10.3166 11.9024 9.68342 11.9024 9.29289 12.2929C8.90237 12.6834 8.90237 13.3166 9.29289 13.7071L11.2929 15.7071C11.6834 16.0976 12.3166 16.0976 12.7071 15.7071L16.7071 11.7071Z"
      fill={theme.palette.custom.mainBlue}
    />
  </svg>
);
export default BlueCheckedSquareIcon;
